export default {
  cashRegister: {
    // 页面提示
    tipLabel: '提示',
    pageTip: '收银台扫码激活后自动进入列表，设备编码由业务系统生成。',
    // 筛选
    deviceCode: '设备编码',
    deviceName: '设备名称',
    store: '归属门店',
    enableStatus: '启用状态',
    onlineStatus: '在线状态',
    activatedTime: '激活时间',
    enabled: '启用',
    disabled: '停用',
    online: '在线',
    offline: '离线',
    // 统计页签
    allTab: '全部收银台',
    // 表格
    softwareVersion: '软件版本',
    edit: '编辑',
    unbind: '解绑',
    unbinding: '解绑中',
    // 空态
    // 编辑抽屉
    editCashRegister: '编辑收银台',
    deviceInfo: '设备信息',
    basicSettings: '基础设置',
    nameRequired: '请输入设备名称。',
    nameLengthLimit: '设备名称不能超过20个字符。',
    nameHint: '1～20个字符',
    namePlaceholder: '例如：1号收银台',
    planned: '规划中',
    salesWarehouse: '销售仓库',
    exchangeWarehouse: '兑换仓库',
    recycleWarehouse: '回收仓库',
    enabledSwitch: '是否启用',
    enabledSwitchHelp: '关闭后，该收银台停用，不能继续使用。',
    coinService: '是否需要加清币',
    coinServiceHelp: '后续支持配置该收银台班次加币 / 清币流程。',
    secondScreenCart: '是否显示副屏购物车',
    secondScreenCartHelp: '后续支持配置顾客副屏是否同步展示购物车内容。',
    confirmStopTitle: '确认停用收银台',
    confirmEnableTitle: '确认启用收银台',
    confirmStopContent: '确认停用「{store} {name}」？停用后，该收银台不能继续使用。',
    confirmEnableContent: '确认启用「{store} {name}」？启用后，该收银台可继续使用。',
    saveSuccess: '设备信息已保存',
    discardChangesTitle: '放弃未保存的修改',
    discardChangesConfirm: '当前页面存在未保存内容，放弃后本次修改将无法恢复。',
    continueEditing: '继续编辑',
    discardChanges: '放弃修改',
    // 解绑
    confirmUnbindTitle: '确认解绑收银台',
    normalUnbindConfirm: '已通过当前业务校验。确认解绑该收银台？解绑后，该收银台将从当前列表移除，不能继续使用；如需再次使用，须重新生成激活码完成激活。',
    blockedTitle: '暂不可解绑',
    blockedPrefix: '当前收银台存在以下未完成业务：',
    forceRiskNoteAllowed: '仅具备强制解绑权限的账号可忽略全部业务校验和设备在线状态继续操作。该操作可能造成未同步数据或业务数据异常。',
    forceRiskNoteDenied: '当前账号没有强制解绑权限，请联系具备权限的管理员处理。',
    forceUnbind: '强制解绑',
    forceUnbindTitle: '强制解绑收银台',
    forceUnbindDesc: '强制解绑将忽略全部业务校验和设备在线状态。解绑成功后，该收银台将移出当前列表。',
    forceUnbindRisk: '可能存在订单、班次或设备数据尚未同步。请确认已经评估相关风险。',
    forceInputLabel: '请输入以下文字以确认',
    forceInputPlaceholder: '请输入风险确认文字',
    forceInputHint: '输入内容必须完全一致，不能包含多余空格。',
    forceUnbindPhrase: '我已知晓风险并确认解绑',
    // 解绑阻断原因（对应后端 UnbindBlockerCodeEnum；未知编码时回退后端 message）
    blockerCode: {
      deviceDisabled: '设备已停用，不能解绑',
      deviceOffline: '设备当前离线',
      orderUnfinished: '存在未完成订单',
      shiftUnclosed: '当前班次尚未交班',
      coinFlowInProgress: '存在进行中的加币/清币流程',
    },
    processingTitle: '正在解绑',
    forceProcessingTitle: '正在强制解绑',
    processingDoNotRepeat: '正在处理，请勿重复操作。',
    processingDesc: '系统正在解除该收银台的当前绑定关系。',
    validatingTitle: '正在校验设备状态',
    validatingHint: '正在校验设备在线状态与未完成业务，请稍候。',
    failureTitle: '解绑失败',
    forceFailureTitle: '强制解绑失败',
    failureDesc: '本次解绑未完成，收银台仍保留在当前列表。请检查网络或系统状态后重试。',
    retryUnbind: '重新解绑',
    unbindSuccess: '解绑成功，该收银台已移出当前列表',
    forceUnbindSuccess: '强制解绑成功，该收银台已移出当前列表',
    // 错误与加载
    listLoadFailed: '收银台列表加载失败，请稍后重试',
    editFailed: '保存失败，请稍后重试',
    checkFailed: '解绑校验失败，请稍后重试',
  },
};
